// `/app/international-withdrawals` (`spec/30-scalefy.md` §5.7, WEB-134): saque do saldo
// internacional em USDT.
//
// O estado da tela vive na query string (`spec/17` §3): `?id=<pedido>` abre o detalhe na
// gaveta, por cima da lista, e `?acquirer=<adquirente>` abre o formulário (é o destino do
// "Sacar em USDT" do saldo). O detalhe fica em `?id=` e não numa rota filha com `<Outlet/>`
// porque `files_allowed` da task não inclui a rota-pai (mesma saída de `app.balance.index`,
// que usa `?entry=`); `app.international-withdrawals.$id` existe pro link direto.

import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import { useMode } from '../app/mode.tsx';
import { InternationalWithdrawalsScreen } from '../features/international-withdrawals/screen.tsx';

/** Query string tolerante a lixo: valor estranho some em vez de derrubar a rota. */
const searchSchema = z.object({
  id: z.string().min(1).optional().catch(undefined),
  acquirer: z.string().min(1).optional().catch(undefined),
});

function InternationalWithdrawals() {
  const search = Route.useSearch();
  const navigate = useNavigate();
  const { mode } = useMode();

  return (
    <InternationalWithdrawalsScreen
      mode={mode}
      selectedId={search.id}
      requestFor={search.acquirer}
      onSelect={(id) => {
        void navigate({ to: '/app/international-withdrawals', search: { id } });
      }}
      onCloseDetail={() => {
        void navigate({ to: '/app/international-withdrawals', search: {} });
      }}
      onCloseRequest={() => {
        void navigate({ to: '/app/international-withdrawals', search: {}, replace: true });
      }}
      onManageWallets={() => {
        void navigate({ to: '/app/settings/crypto-wallets' });
      }}
    />
  );
}

export const Route = createFileRoute('/app/international-withdrawals/')({
  validateSearch: searchSchema,
  component: InternationalWithdrawals,
});
